import { useState } from 'react';
import { PageHub } from '../components/PageHub';
import type { WidgetDef, WidgetShow } from '../api';
import { WidgetView } from '../components/Widgets';
import { useApp } from '../context';

/** Mijn lijst: de Plex-watchlist van dit profiel (dezelfde als in de Plex-apps). */
export function MyList() {
  const { me } = useApp();
  const plex = me.plex !== false;
  const [show, setShow] = useState<WidgetShow>('all');
  const w: WidgetDef = {
    id: `mylist-${show}`,
    title: 'Mijn lijst',
    source: { kind: 'plex', list: 'watchlist' },
    view: 'wall',
    show,
    limit: 100,
    enabled: true,
  };
  return (
    <main className="page mylist-page">
      <PageHub page="mylist" />
      <header className="page-head">
        <h1>Mijn lijst</h1>
      </header>
      {plex && <div className="chip-wrap mylist-filter" data-focus-group>
        {([['all', 'Alles'], ['owned', 'In bibliotheek'], ['missing', 'Nog niet in bibliotheek']] as const).map(([id, label]) => (
          <button key={id} className="chip" aria-pressed={show === id} onClick={() => setShow(id)}>{label}</button>
        ))}
      </div>}
      <WidgetView key={show} w={w} preview />
      <p className="subtle hint mylist-hint">
        {plex
          ? 'Zet titels op je lijst met "+ Mijn lijst" op een infopagina. Het is je Plex-watchlist, dus je ziet hem ook in de Plex-apps.'
          : 'Zet titels op je lijst met "+ Mijn lijst" op een infopagina (bij addons of in een rij). De lijst hoort bij dit profiel.'}
      </p>
    </main>
  );
}
